// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { ResourceValidationResultFragmentFragment } from '../../../../shared/graphql/fragments/generated/resource-validation-result.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ValidateElectronicInvoiceQueryVariables = Types.Exact<{
  invoiceId: Types.Scalars['Int']['input'];
}>;


export type ValidateElectronicInvoiceQueryResult = { __typename?: 'Query', validateElectronicInvoice: { __typename?: 'ValidateElectronicInvoiceResponseDTO', xsdValidationError: string | null, resourceValidationResults: Array<{ __typename?: 'ResourceValidationResultDTO', resourceId: number, validationErrors: Array<{ __typename?: 'ValidationErrorDTO', errorCode: string, fieldName: string | null, translationKey: string } | null> | null }> } };

export const ValidateElectronicInvoiceGql = gql`
    query ValidateElectronicInvoice($invoiceId: Int!) {
  validateElectronicInvoice(invoiceId: $invoiceId) {
    xsdValidationError
    resourceValidationResults {
      ...ResourceValidationResultFragment
    }
  }
}
    ${ResourceValidationResultFragmentFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ValidateElectronicInvoiceInjectable extends Apollo.Query<ValidateElectronicInvoiceQueryResult, ValidateElectronicInvoiceQueryVariables> {
    override document = ValidateElectronicInvoiceGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */